import * as React from 'react';
import PhoneNumber from '../../models/phone-number';
import { Icon } from '@teamsnap/teamsnap-ui';

export interface Props {
  phoneNumber: PhoneNumber;
}

const PhoneNumberInfo: React.FunctionComponent<Props> = ({ phoneNumber }) => {
  const noShowLabels = ['other', null];
  const phoneNumberLabel = noShowLabels.includes(phoneNumber.label) ? '' : '(' + phoneNumber.label + ')';

  return (
    <div className="u-spaceBottomSm">
      <Icon name="megaphone" mods="u-spaceRightSm u-colorGrey" />
      <span className="u-padTopSm">{phoneNumber.number}</span>
      {phoneNumber?.label && <span className="u-spaceLeftXs">{phoneNumberLabel}</span>}
    </div>
  );
};

export default PhoneNumberInfo;
